import React from 'react';
import styled from "styled-components";
import RecoveryPassword from "../forms/RecoveryPassword";
import CustomModal from "./index";
import {updateModalResetPassword} from "redux/reducers/appSlice";
import {useTypedSelector} from "hooks/useTypedRedux";
import {selectModalResetPassword} from "redux/selectors/modalSelector";

const RecoveryPasswordModal = () => {

    const open = useTypedSelector(selectModalResetPassword)

    return (
        <>
            <CustomModal open={open} updateOpen={updateModalResetPassword}
                         styles={{borderRadius: '10px'}}>
                <Wrapper>
                    <RecoveryPassword/>
                </Wrapper>
            </CustomModal>
        </>
    );
};

export default RecoveryPasswordModal;


const Wrapper = styled.div`
  width: 360px;
  height: 425px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

`